module.exports = __webpack_public_path__ + "static/Chaupal-bf26e2a2f63cba7562ecad308fb995e4.jpg";